export const RoleListTableLabelConst = [
	'No',
	'Role Name',
	'Role Description',
	'Total Assignment',
	'Action',
];

export const RoleListTableColumnConst = [
	'no',
	'name',
	'description',
	'numUser',
	'action',
];
